import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useUserdata } from "src/store/UserData";
import * as AppConfig from "src/helpers/AppConfig";

interface SidebarButtonProps {
  path?: string;
  name: string;
  id?: string;
  icon?: string;
  messagesCount?: number;
  permissions: string[];
  submenu: SubmenuProps[];
}

interface SubmenuProps {
  path: string;
  name: string;
  icon?: string;
  permissions: string[];
}

const SidebarButton: React.FC<SidebarButtonProps> = ({
  id,
  path,
  icon,
  name,
  permissions,
  submenu,
  messagesCount,
}) => {
  const userData = useUserdata((state: any) => state.userData);

  const convertPermissionsToArray = (
    permissionsObject: Record<string, boolean>
  ) => {
    return Object.keys(permissionsObject).filter(
      (key) => permissionsObject[key]
    );
  };

  const [userPermissions, setUserPermissions] = useState<string[]>([]);

  useEffect(() => {
    const localPermissions = AppConfig.accessData("permissions") as string[];

    if (localPermissions) {
      const userPermissionsArray = convertPermissionsToArray(
        userData.permissions
      );

      // Check if permissions arrays match
      if (
        localPermissions.sort().join() === userPermissionsArray.sort().join()
      ) {
        setUserPermissions(userPermissionsArray);
      } else {
        setUserPermissions(localPermissions);
      }
    } else {
      AppConfig.deleteAccessToken();
    }
  }, [userData]);

  const hasPermission = (requiredPermissions: string[]) => {
    return requiredPermissions.some((permission) =>
      userPermissions.includes(permission)
    );
  };
  return (
    <>
      {hasPermission(permissions) &&
        (submenu.length > 0 ? (
          <div className="menu-item">
            <button
              className="collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#${id}`}
              aria-expanded="false"
              aria-controls={id}
            >
              {icon && <i className={`icon ${icon}`} />}
              <span>{name}</span>

              {/* {messagesCount && messagesCount > 0 && (
                <span
                  className="rounded-pill red"
                  style={{
                    marginTop: "0px",
                  }}
                >
                  {messagesCount}
                </span>
              )} */}
              <i className="icon sidebar-arrow ms-auto" />
            </button>
            <div
              aria-labelledby={id}
              data-bs-parent="#sidebar-menu"
              id={id}
              className="collapse"
            >
              <ul className="sub-menu list-unstyled">
                {submenu.map((menu, index) =>
                  hasPermission(menu.permissions) ? (
                    <li key={index}>
                      <NavLink to={menu.path}>{menu.name}</NavLink>
                    </li>
                  ) : null
                )}
              </ul>
            </div>
          </div>
        ) : (
          <NavLink to={path ? path : ""} className="menu-item">
            <button className="collapsed" type="button">
              {icon && <i className={`icon ${icon}`} />}
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{name}</span>
                {id === "chat" && messagesCount && messagesCount > 0 ? (
                  <span
                    className="rounded-pill red"
                    style={{ marginLeft: "110px", color: "white" }} // color: "white",padding:"3px 3px",fontSize:"12px"
                  >
                    {messagesCount}
                  </span>
                ) : (
                  ""
                )}
              </div>
            </button>
          </NavLink>
        ))}
    </>
  );
};

export default SidebarButton;
